import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { getHttpHeaders } from '@commons/utility/util';

import { environment } from '@environments/environment';

import { CustomResponseDto } from '@core/model/custom-response-dto';

@Injectable()
export class PasswordVerificationService {
  private apiUrl = environment.apiUrl;
  private passwordMatchingUrl = `${this.apiUrl}origination/validation-password/password-matching/{password}/{confirmPassword}`;

  private headers = getHttpHeaders();

  constructor(private http: HttpClient) {}

  public verifyPasswordMatching(password: string, confirmPassword: string): Observable<CustomResponseDto<boolean>> {
    return this.http.get<any>(
      this.passwordMatchingUrl.replace('{password}', password).replace('{confirmPassword}', confirmPassword),
      { headers: this.headers }
    );
  }
}
